import { Component, OnInit } from '@angular/core';
import { AppConfig } from '../../../../config/routes.config';
import { ActivatedRoute, Router } from '@angular/router';
import { IonNav, NavController } from '@ionic/angular/standalone';
import { SharedBookingsAccessListPage } from '../shared-bookings-access-list/shared-bookings-access-list.page';
import { IonContent, IonButton } from "@ionic/angular/standalone";
import { IconComponent } from "../../../../../shared/components/elements/icon/icon.component";
import { NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
	selector: 'vl-shared-access-successfully',
	templateUrl: './shared-access-successfully.page.html',
	styleUrls: ['./shared-access-successfully.page.scss'],
 imports: [IonButton, IconComponent, IonContent, NgIf, TranslatePipe],
})
export class SharedAccessSuccessfullyPage implements OnInit {
	message;
	routes = AppConfig.routes;
	type: 'failed' | 'success' = 'success';
	bookingId;

	constructor(private nav: IonNav) { }

	ngOnInit() {
		this.setState();
	}


	setState() {
		if (this.type === 'success') {
			this.message = 'share-access.success';
		} else {
			this.message = 'share-access.failed';
		}
	}

	goTo() {
		if (!this.bookingId) {
			throw  new Error('bookingId is missed!')
		}
		this.nav.push(SharedBookingsAccessListPage, {bookingId: this.bookingId});
	}

}
